import {moment} from 'helpers';

// attach current timestamp to all actions
export function timestamp() {
  return next => action => {
    next({
      timestamp: moment().unix(),
      timestamp_today: moment().startOf('day').unix(),
      timestamp_ms: moment().valueOf(),
      ...action,
    });
  }
}
